<template>
<el-card shadow="never" :body-style="{ padding: '20px' }" class="mb-4 mx-auto">
    <div class="mx-auto p-1 text-gray-600">
        <h2 class="text-2xl mb-4">FAQ</h2>
        <div class="mb-4">
            <h3 class="font-bold mb-1">What is Bilibili Downloader?</h3>
            <p>
                Bilibili Downloader is a free tool that lets you download videos from Bilibili (bilibili.com) for offline viewing. Save your favorite anime, gaming videos, and more in original quality.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">How does Bilibili Downloader work?</h3>
            <p>
                Our Bilibili video downloader uses a Chrome extension to find and extract video URLs from Bilibili pages. Simply paste the video URL, and the extension will locate the downloadable media files for you.
            </p>
        </div>

        <div class="mb-4">
            <h3 class="font-bold mb-1">Is Bilibili Downloader free to use?</h3>
            <p>
                Yes, Bilibili Downloader is completely free to use. Simply install the Chrome extension and start downloading videos from Bilibili without any subscription fees.
            </p>
        </div>

        <div>
            <h3 class="font-bold mb-1">What video quality can I download from Bilibili?</h3>
            <p>
                You can download Bilibili videos in various qualities including 720p, 1080p, and even higher resolutions when available. The downloader preserves the original quality of the uploaded video.
            </p>
        </div>
    </div>
</el-card>
</template>

<script>
export default {

}
</script>

<style>

</style>
